import { Trans, useLingui } from '@lingui/react/macro';

import Button from '@/design_system/Button';
import Stack from '@/design_system/Stack';
import Title from '@/design_system/Typography/Title';
import IconChevron from '@/icons/Chevron.svg';
import { useSettingsNavGroups } from '@/layouts/App/SettingsNavbar/SettingsNavbar';

const buttonHeight = '56px';

export const SettingsMobileMenu = () => {
  const { t } = useLingui();
  const groups = useSettingsNavGroups();

  return (
    <>
      <div className="header">
        <Stack row alignItems="center" gap="1rem">
          <Button
            iconOnly
            variant="secondary"
            to="/menu"
            ariaLabel={t({ id: 'settings-mobile-menu.back', message: 'Back to menu' })}
          >
            <IconChevron left />
          </Button>
          <Title size="200" as="h1">
            <Trans id="settings-mobile-menu.title">Settings</Trans>
          </Title>
        </Stack>
      </div>

      <div className="container">
        <Stack gap="24px">
          {groups.map((group) => (
            <Stack key={group.id} gap="0.5rem">
              <Title as="h2" size="400" weight="medium" color="secondary">
                {group.label}
              </Title>
              {group.items.map((item) => (
                <Button
                  key={item.id}
                  to={item.to}
                  variant="secondary"
                  size="medium"
                  style={{ height: buttonHeight }}
                >
                  <Stack
                    row
                    gap="0.5rem"
                    alignItems="center"
                    justifyContent="space-between"
                    style={{ width: '100%' }}
                  >
                    <Stack row gap="0.5rem" alignItems="center" style={{ fontSize: '1.25rem' }}>
                      {item.icon}
                      <span style={{ fontSize: 'initial' }}>{item.label}</span>
                    </Stack>
                    <IconChevron right />
                  </Stack>
                </Button>
              ))}
            </Stack>
          ))}
        </Stack>
      </div>
    </>
  );
};
